
import {initWebComponent} from "@/helpers/web-component-helper";

const template = document.createElement('template');
template.innerHTML = `<header-button data-icon="fa fa-expand-arrows-alt" data-tooltip="openFullScreen"></header-button>`;

let isFullScreen = false

export class HeaderFullScreenComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {

              var elem = document.documentElement;

              if(isFullScreen) {
                isFullScreen = false
                if (document.exitFullscreen) {
                  document.exitFullscreen();
                } else if (document.webkitExitFullscreen) { /* Safari */
                  document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) { /* IE11 */
                  document.msExitFullscreen();
                }
              } else {

                isFullScreen = true
                if (elem.requestFullscreen) {
                  elem.requestFullscreen();
                } else if (elem.webkitRequestFullscreen) { /* Safari */
                  elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) { /* IE11 */
                  elem.msRequestFullscreen();
                }
              }
        });
    }
}

